import YUSPUtil from '../../util/yusp_util';

import { RrRepository } from '../..//repositories/rr_repository';
import { SiteType, isSoloare } from '../../models/js_env';
import StorageUtil from '../../util/storage_util';
import { MyCatalogRegisterRepository } from '../../repositories/my_catalog_register_repository';
import { FavoriteItemJsEnv } from '../../models/my_catalog_register/favorite_item_js_env';
import { Env } from '../../env';
import { TypedEvent } from '../../typed_event';
import { SupplierId } from '../../models/supplier_id';
import { AnalyticsItem } from '../../models/analytics/analytics_item';
import { AnalyticsItems } from '../../models/analytics/analytics_items';
import {
  createRrItemModalRequestParam
} from '../../models/my_catalog_register/rr/set_rr_request';
import { getRrAreaData } from '../../models/rr/rr_util';
import { MyCatalogModal } from '../../models/my_catalog_register/my_catalog_modal';
import { RrItemModalContainer } from '../../views/pc/my_catalog_register/rr/rr_container';

/// ローカルストレージカゴお気に入りモーダル非表示キー論理名
const HIDE_CART_FAVORITE_MODAL_KEY = 'HIDE_CART_FAVORITE_MODAL';
/// ローカルストレージカゴお気に入りモーダル非表示の設定値
const HIDE_CART_FAVORITE_MODAL_VALUE = '1';
/// ローカルストレージカゴお気に入りモーダル非表示の有効日数
const HIDE_CART_FAVORITE_MODAL_DATE_LIMIT = 30;

// お気に入りリスト画面URL（SOLOARE）
export const MY_CATALOG_SOLOARE_URL = Env.SETTING.soloareFront.urlBase + 'buyer/view/a080/DAD04020.html?transit=Header';
// お気に入りリスト画面URL（CLUB）
export const MY_CATALOG_CLUB_URL = Env.SETTING.clubFront.urlBase + 'tpc/mycatalog/myCatalogListView/';
// お気に入りリスト画面URL（TRYLION）
export const MY_CATALOG_TRYLION_URL = '/purchase_management/favorite_list/favorite_list/'
// location.href 属性
const LOCATION_HREF = "location.href="

const MODAL_SCROLL_LOCK_CLASS = "is-scrollLock";

export class MyCatalogRegisterAction {
  private static rrRepository: RrRepository;
  static readonly MY_CATALOG_REGISTER_EVENT = new TypedEvent<AnalyticsItems>();
  private static myCatalogModal: MyCatalogModal;
  static readonly RR_ITEM_Modal_EVENT = new TypedEvent<MyCatalogModal>();

  /// お気に入り追加モーダル「選択したフォルダに登録」クリック処理
  static async myCatalogInsertSelectedFolder(
    supplierId: string,
    catalogItemCode: string,
    medicalMaterialType: string
  ) {

    // YUSP連携 ユーザーID連携、ADD_TO_FAVORITEイベント
    YUSPUtil.register({
      enableUserId: true,
      enableAddToFavorites: { catalogItemCode },
    });

    // モーダルのレコメンドエリアに必要なインスタンスを用意
    this.myCatalogModal = new MyCatalogModal();
    this.rrRepository = new RrRepository();
    new RrItemModalContainer(); // NOSONAR

    // ソロアリ以外かつ利用機能制御「おすすめ情報の表示」がONか？
    const model = this.myCatalogModal;
    const shouldDisplayRecommend = !isSoloare(Env.SITE_TYPE) && model.shouldDisplayRecommend && window['RR'] !== undefined;

    // Click時のイベント処理
    const clickFunction = async function (event: Event) {
      const hideCartFavoriteLocalStorageValue = StorageUtil.getItemWithExpiration(HIDE_CART_FAVORITE_MODAL_KEY);
      // この画面を一定期間表示しないがチェックされているか？
      const isCheckedToHideRichModal = hideCartFavoriteLocalStorageValue === HIDE_CART_FAVORITE_MODAL_VALUE;
      if (!isCheckedToHideRichModal && shouldDisplayRecommend) {
        // おすすめを表示する場合、モーダルのレコメンドエリアを設定
        MyCatalogRegisterAction.myCatalogModalRrRecommend(catalogItemCode);
      }

      const checkedFolder: { [key: string]: string; } = MyCatalogRegisterAction.getCheckedFolderValue();

      const result: FavoriteItemJsEnv =
        await new MyCatalogRegisterRepository().favoriteItem(
          supplierId,
          catalogItemCode,
          Number(checkedFolder["folderShareType"]),
          Number(checkedFolder["folderCode"]),
          checkedFolder["folderManagerId"],
        );

      /// お気に入り更新エラー処理
      const errorMessageArea = document.getElementById('my_catalog_errorMessageArea') as HTMLInputElement;
      const errorMessage = document.getElementById('my_catalog_errorMessage') as HTMLInputElement;
      errorMessageArea.style.display = 'none';

      if (result.isError) {
        errorMessageArea.style.display = 'block';
        errorMessage.innerText = result.errorMessage;
        return;
      }

      ///　お気に入りモーダル　AdobeAnalytics
      const registerButton = document.getElementById('my-catalog-insert-selected-folder');
      MyCatalogRegisterAction.myCatalogRegisterAnalytics(registerButton, catalogItemCode, supplierId, medicalMaterialType);

      /// お気に入り追加モーダルを閉じる
      await MyCatalogRegisterAction.closeModal('modal-SLPSRC016-01');

      /// 登録完了モーダル出し分け処理
      if (isCheckedToHideRichModal) {
        /// 簡易
        const sImageElement: HTMLImageElement = <HTMLImageElement>document.querySelector('img#my-catalog-item-image');
        sImageElement.setAttribute('data-src', result.sImage);

        MyCatalogRegisterAction.myCatalogSimpleTooltipLink();

        if (!document.querySelector('#my-catalog-tooltip')?.classList.contains('is-shown')) {
          (document.querySelector('#my-catalog-tooltip-trigger') as HTMLButtonElement)?.click();
        }

      } else {
        /// リッチ
        /// RRのJS遅延読み込み。レイアウト崩れ防止対策
        new Promise(resolve => setTimeout(resolve, 1000))
          .then(() => {
            const WindowCarousel = (window as any)._carousel
            return new WindowCarousel('#recomRR_myCataModal_01-carousel');
          })
          .then(() => {
            (document.querySelector('#my-catalog-open-register-complete') as HTMLButtonElement)?.click();
          });
      }
      event.preventDefault();
      event.stopPropagation();
    }

    document.querySelector('#my-catalog-insert-selected-folder')?.addEventListener(
      'click',
      (event: Event) => {
        clickFunction(event);
      }
    );
  }

  /// カゴに入れるモーダルの一定期間非表示チェックボックス押下処理
  static checkedMyCatalogRegisterViewCheckbox() {
    StorageUtil.setItemAfterDates(
      HIDE_CART_FAVORITE_MODAL_KEY,
      HIDE_CART_FAVORITE_MODAL_VALUE,
      HIDE_CART_FAVORITE_MODAL_DATE_LIMIT
    );
  }

  /// 登録完了（簡易）ツールチップ 「お気に入りリストへ」ボタンクリック時の遷移先設定
  private static myCatalogSimpleTooltipLink() {

    const linkElement: HTMLButtonElement = <HTMLButtonElement>document.querySelector('#my-catalog-to-my-catalog-link');

    switch (Env.SITE_TYPE) {
      case SiteType.CLUB:
        linkElement.setAttribute("onclick", LOCATION_HREF + "'" + MY_CATALOG_CLUB_URL + "'");
        break;
      case SiteType.SOLOARE:
        linkElement.setAttribute("onclick", LOCATION_HREF + "'" + MY_CATALOG_SOLOARE_URL + "'");
        break;
      default:
        linkElement.setAttribute("onclick", LOCATION_HREF + "'" + MY_CATALOG_TRYLION_URL + "'");
        break;
    }
  }

  /// カゴに入れるモーダルの一定期間非表示チェックボックス押下解除処理
  static uncheckedMyCatalogRegisterViewCheckbox() {
    localStorage.removeItem(HIDE_CART_FAVORITE_MODAL_KEY);
  }

  /// お気に入り追加モーダル 選択中フォルダの「フォルダ共有区分」・「お気に入りフォルダコード」を取得
  static getCheckedFolderValue(): { [key: string]: string; } {
    const checkedElement: HTMLInputElement = <HTMLInputElement>document.querySelector('input[name="myCatalogFolder"]:checked');
    const checkedFolder: { [key: string]: string; } = {};
    checkedFolder["folderShareType"] = checkedElement?.dataset?.folderShareType ?? "";
    checkedFolder["folderCode"] = checkedElement?.value ?? "";
    checkedFolder["folderManagerId"] = checkedElement?.dataset?.folderManagerId ?? "";
    return checkedFolder;
  }

  /// モーダルを閉じる
  private static closeModal(modalId: string) {
    /*
    エンハンス「非在庫UI改善」で、マイカタへの登録完了後にモーダルを閉じると、
    スクロールバーが非表示のままとなり画面を縦スクロールできない、という不具合が発生（SALES_FLOOR-257）。
    その原因は、openModalIds.pop()をしていないことだった。
    この処理はCX側の閉じる処理に実装されており、開発側はそのCX処理を呼び出してモーダルを閉じるべきだが、
    実際にはそうせずに独自実装によりモーダルを閉じてしまっている。
    本不具合は非在庫UI改善の本番リリース直前に検知されたため、CX処理に切り替える抜本的な修正による品質リスクを考慮し、
    CX処理で担当するべきopenModalIds.pop()を開発側で直接呼び出すように暫定対応した。
    本格対応（CX処理を呼び出すように統一する修正）は、ハイパーケアで実施予定。
    */
    const openModalIds = (window as any)._openModalIds;
    if (openModalIds) {
      openModalIds.pop();
    }

    const modalElement = document.querySelector('#' + modalId);
    modalElement?.setAttribute('aria-hidden', 'true');
    modalElement?.classList.remove('is-open');

    let scrollLockElement = document.getElementsByClassName(MODAL_SCROLL_LOCK_CLASS)[0]
    if(scrollLockElement != null) {
      scrollLockElement.classList.remove(MODAL_SCROLL_LOCK_CLASS);
    }
  }

  /// お気に入りモーダル AdobeAnalytics
  static myCatalogRegisterAnalytics(e, catalogItemCode, supplierId, medicalMaterialType) {
    const item = new AnalyticsItem();
    item._catalogItemCode = catalogItemCode;
    item._supplierId = new SupplierId(supplierId);
    item._medicalMaterialType = medicalMaterialType;

    const adobeAnalyticsData: AnalyticsItems = {
      linkName: 'RegistFavorite',
      target: e,
      analyticsData: { items: [item] }
    };
    this.MY_CATALOG_REGISTER_EVENT.trigger(adobeAnalyticsData);
  }

  private static myCatalogModalRrRecommend(catalogItemCode: string) {
    const model = this.myCatalogModal;
    window['RR'].jsonCallback = this.renderRrModal.bind(this);
    this.rrRepository.sendRequestToRrServer(createRrItemModalRequestParam(model, catalogItemCode));
  }

  private static async renderRrModal() {
    const model = this.myCatalogModal
    const rrAreaProfileItemModal = await getRrAreaData(model.rrAreaProfileMyCatalogModal)
    this.myCatalogModal.setRrAreaDataMyCatalogModal(rrAreaProfileItemModal.items, rrAreaProfileItemModal.title);
    if (rrAreaProfileItemModal.items.length > 0) {
      this.RR_ITEM_Modal_EVENT.trigger(model);
    }
  }
}
